<template>
	<v-list-item-title v-if="type === 'item'" v-html="text" :title="text" :style="'white-space: unset !important;'"></v-list-item-title>
	<span v-else class="pr-2" :class="compClass">{{ text }}</span>
</template>

<script>
export default {
	name: 'PuiSelectTextService',
	data: () => ({}),
	props: {
		item: {
			type: [Object, String, Number],
			required: true
		},
		type: {
			type: String,
			default: 'item',
			required: false
		},
		itemText: {
			type: [Function, String, Array],
			required: true
		},
		truncate: {
			type: Boolean,
			default: false,
			required: false
		},
		writing: {
			type: Boolean,
			default: false,
			required: false
		},
		disabled: {
			type: Boolean,
			default: false,
			required: false
		}
	},
	computed: {
		text() {
			let customText;
			if (this.itemText instanceof Function) {
				customText = this.itemText(this.item);
			} else if (Array.isArray(this.itemText)) {
				customText = this.itemText.slice(1).reduce((a, b) => {
					return `${a} - ${b}`;
				}, this.itemText[0]);
			}

			return customText || this.item[this.itemText];
		},
		compClass() {
			return {
				'puiselect-text-truncate': this.truncate && !this.writing && !this.disabled,
				'puiselect-text': !this.writing
			};
		}
	}
};
</script>
